import { Skeleton, Typography } from '@mui/material'
import React from 'react'
import BodyHeader from '../molecules/BodyHeader'
import TitleSubtitle from '../molecules/TitleSubtitle'
import Zone from '../organisms/Zone'

import useDiy from '../../hooks/useDiy'
import useBricotheque from '../../hooks/useBricotheque'
import chairIcon from '../../media/chair_green_icon.svg'

const Diy = () => {
	const { isLoading, title, content, hours, address } = useDiy()
	const { bricotheques } = useBricotheque()

	return (
		<>
			{(isLoading && <Skeleton />) || (
				<>
					{bricotheques && (
						<BodyHeader title={title} list={bricotheques} infoLabel1={hours} infoLabel2={address}>
							{content}
						</BodyHeader>
					)}
				</>
			)}

			{bricotheques &&
				bricotheques.map(({ id, type, slug, title, content, image }, index) => (
					<Zone color={(index % 2 === 0 && 'white') || 'ivory'} key={id} id={slug}>
						<TitleSubtitle title={type} subtitle={title} />
						<Typography
							sx={(theme) => ({
								color: 'text.primary',
								textAlign: 'left',
								fontSize: 18,
								mt: 4,
								display: 'flex',
								width: '100%',
								flexFlow: (index % 2 === 1 && 'row-reverse wrap') || 'row wrap',
								fontFamily: 'montserrat',
								justifyContent: 'space-between',

								px: 2,

								[theme.breakpoints.down('md')]: {
									mt: 2,
								},

								'& figure': {
									pt: 4,
									m: 0,
									display: 'flex',
									justifyContent: (index % 2 === 0 && 'flex-start') || 'flex-end',

									flexBasis: '47%',

									[theme.breakpoints.down('md')]: {
										pt: 0,
										flexBasis: '100%',
									},

									'& img': {
										display: 'block',
										overflow: 'hidden',
										borderRadius: '8px',

										height: 'fit-content!important',
										width: '100%!important',

										[theme.breakpoints.down('md')]: {
											width: '100%',
										},
									},
								},

								'& em': {
									fontSize: 16,
								},

								'& a': {
									color: 'secondary.main',
									fontWeight: 'bold',
								},

								'& h2': {
									fontSize: 22,
									fontWeight: 800,
									color: 'text.primary',
									mb: 2,
									background: (theme) => `url(${chairIcon}) no-repeat ${theme.spacing(0, 1)}`,
									pl: 4.5,
									display: 'table',
									[theme.breakpoints.down('md')]: {
										fontSize: 19,
										backgroundPositionY: 6,
										backgroundSize: 15,
										pl: 3,
										fontWeight: 900,
									},
								},

								'& .wp-block-group': {
									flexBasis: '47%',

									[theme.breakpoints.down('md')]: {
										flexBasis: '100%',
									},
								},
								'& pre': {
									borderLeft: `4px solid ${theme.palette.secondary.main}`,
									fontWeight: 700,
									fontFamily: 'montserrat',
									p: theme.spacing(0, 0, 0, 2),

									whiteSpace: 'break-spaces',
									'& .MuiTypography-root': {
										[theme.breakpoints.down('md')]: {
											fontSize: 16,
										},
									},
								},

								'& blockquote': {
									m: 0,
									my: 2,
									fontSize: 22,
									'& p': {
										fontWeight: 'bold',
										mb: 0,
									},

									'& cite': {
										fontSize: 16,
										fontWeight: 400,
										position: 'relative',
										fontStyle: 'normal',
										textAlign: 'right',
										display: 'block',
									},
								},

								'& .wp-block-button__link': {
									fontFamily: 'museomoderno',
									cursor: 'pointer',
									position: 'relative',
									display: 'table',
									justifyContent: 'space-around',
									borderRadius: '28px',
									fontSize: 16,
									p: theme.spacing(1, 2),
									bgcolor: 'secondary.main',
									color: 'white',
									fontWeight: 700,
									my: theme.spacing(2),
									border: `3px solid ${theme.palette.secondary.main}`,

									'&:hover': {
										bgcolor: 'secondary.main',
										border: `3px solid ${theme.palette.secondary.main}`,
									},

									[theme.breakpoints.down('md')]: {
										m: theme.spacing(0, 'auto'),
										mt: 10,

										'& a': {
											display: 'flex',
											p: 3,
											border: 'none',
										},
									},
								},

								'& div': { width: '100%' },
							})}
							component="div"
							dangerouslySetInnerHTML={{ __html: content }}
						/>
					</Zone>
				))}
		</>
	)
}

export default Diy
